import React from "react";
import { Trans } from "@lingui/macro";
import { ViewComponent } from "./ViewComponent";
import { useDispatch, useSelector } from "react-redux";
import { useInputChange } from "../../../../hooks/useInputChange";
import { typeArchiveSalesFilters } from "../../../../model/dashboardSalesArchive/reducer";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";
import {
  selectSalesArchiveFilters,
  selectSalesArchivePagination,
  selectSalesArchiveReceiptNumber,
  selectSalesArchiveSalePublicId,
} from "../../../../model/dashboardSalesArchive/selectors";
import {
  dSalesArchiveSetFiltersAC,
  dSalesArchiveSetDataSagaAC,
  dSalesArchiveClearFiltersAC,
  dSalesArchiveSetPageNumberAC,
  dSalesArchiveSetDetailItemAC,
  dSalesArchiveSetItemsForPageAC,
} from "../../../../model/dashboardSalesArchive/actionCreators";

export type typeSales = {
  variant?: string;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export type typeDataSalesRowActions = {
  title: React.JSX.Element;
  action: (id: string) => void;
}[];

export const DataSalesArchive: React.FC<typeSales> = ({
  variant,
  setSidebarOpen,
}) => {
  const dispatch = useDispatch();

  const filters = useSelector(selectSalesArchiveFilters);
  const paginationObject = useSelector(selectSalesArchivePagination);
  const searchStorePublicId = useSelector(selectSalesArchiveSalePublicId);
  const searchArchiveStoreReceiptNumber = useSelector(
    selectSalesArchiveReceiptNumber,
  );

  const [openFilterBar, setOpenFilterBar] = React.useState(false);
  const [openPopupPrint, setOpenPopupPrint] = React.useState(false);
  const [isActiveFilters, setIsActiveFilters] = React.useState(false);
  const [openPopupDetails, setOpenPopupDetails] = React.useState(false);

  const pagination: typePaginationDashboardObject = {
    paginationObject,
    onGoToPage: (id) => dispatch(dSalesArchiveSetPageNumberAC(id)),
    onSelectItems: (itemsPerPage) => {
      return dispatch(dSalesArchiveSetItemsForPageAC(itemsPerPage));
    },
  };

  React.useEffect(() => {
    return () => {
      dispatch(dSalesArchiveClearFiltersAC());
    };
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      dSalesArchiveSetDataSagaAC(filters, {
        page: pagination.paginationObject.pageNumber,
        size: pagination.paginationObject.itemsPerPage!,
      }),
    );
  }, [
    filters,
    dispatch,
    pagination.paginationObject.pageNumber,
    pagination.paginationObject.itemsPerPage,
  ]);

  const {
    value: searchValue,
    setValue: setSearchValue,
    changeValueHandler: onChangeSearchValue,
  } = useInputChange(
    searchStorePublicId || searchArchiveStoreReceiptNumber || "",
  );

  const onClearSearch = () => {
    dispatch(
      dSalesArchiveSetFiltersAC({
        salePublicId: null,
        receiptNumber: null,
      }),
    );

    setSearchValue("");
  };

  const onEnterSearch = () => {
    const filters: typeArchiveSalesFilters = {
      salePublicId: searchValue.trim(),
      receiptNumber: searchValue.trim(),
    };

    dispatch(dSalesArchiveSetFiltersAC(filters));
  };

  const rowsActions: typeDataSalesRowActions = [
    {
      title: <Trans>Print</Trans>,
      action: (id: string) => {
        dispatch(dSalesArchiveSetDetailItemAC(id));

        setOpenPopupPrint(true);
      },
    },
  ];

  const cancelPrint = () => {
    setOpenPopupPrint(false);
  };

  const printHandler = () => {
    setOpenPopupPrint(false);
  };

  return (
    <ViewComponent
      variant={variant}
      pagination={pagination}
      rowsActions={rowsActions}
      searchValue={searchValue}
      onCancelPrint={cancelPrint}
      openFilterBar={openFilterBar}
      onEnterSearch={onEnterSearch}
      onClearSearch={onClearSearch}
      setSidebarOpen={setSidebarOpen}
      openPopupPrint={openPopupPrint}
      isActiveFilters={isActiveFilters}
      onPrintSubmitClick={printHandler}
      setOpenFilterBar={setOpenFilterBar}
      openPopupDetails={openPopupDetails}
      setOpenPopupPrint={setOpenPopupPrint}
      setIsActiveFilters={setIsActiveFilters}
      setOpenPopupDetails={setOpenPopupDetails}
      onChangeSearchValue={onChangeSearchValue}
    />
  );
};
